/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import { ArrowLeftOutlined, CloudUploadOutlined, DeleteOutlined, EditOutlined, EyeOutlined, FilterOutlined } from '@ant-design/icons';
import {
    Button, Form,
    Input,
    Modal,
    Space,
    Table,
    Tabs,
    Tooltip,
    Typography,
    Upload, notification, DatePicker, Drawer, Select, Layout
} from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';

import history from '../../services/history';
import ProjectModal from './ProjectModal';
import MasterModal from './MasterModal';
import { fetchRecordList } from '../../redux/Trackrecord/action';
import MasteForm from './Welding/MasteForm';
import { AddOrUpdateProject, DeleteTrackRecordDetails, GeneratetrackRecordReport, GetRecordListExcel, getFilterCategoryListFromDatabse } from '../../redux/Trackrecord/saga';
import { authenticateCurrentUser } from '../../services/auth';
import { Content, Footer } from 'antd/lib/layout/layout';
import WeldingRecordPage from './Welding/WeldingRecordPage';
import CoatingRecordPage from './Coating/CoatingRecordPage';
import ComingSoon from '../Comingsoon';



const { Option } = Select;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
//const { TabPane } = Tabs;
//const { Column } = Table;
//const { Search } = Input;

//const { Option } = Select;
const TrackRecordPage = (props) => {

    const {
      
    } = props;

  
  

    const [activeKey, setActiveKey] = useState('1')
    const [activeKeyLine, setActiveKeyLine] = useState('1')
    const factor = 0.621371;
    const [isMasterModalVisible, setIsMasterModalVisible] = useState(false);
    const [selectedTap, setSelectedTap] = useState('Welding');
    const [tapsList, setTaplist] = useState(['Welding', 'Coating', 'Competitor']);
 
    const handleTabChange = (key) => {

        setActiveKeyLine(key);
        setSelectedTap(tapsList[Number(key) - 1])

    };

   
    const getRecordTabpanes = () => {
        return (
            <div className="custom-tab h-100" style={{ paddingTop: '10px' }}>
                <Tabs defaultActiveKey='1' activeKey={activeKeyLine} onChange={handleTabChange}  >
                    {
                        <TabPane tab='Welding' key='1'>
                            <WeldingRecordPage selectedTap={selectedTap}  isMasterModalVisible ={isMasterModalVisible} setIsMasterModalVisible  ={setIsMasterModalVisible }/>
                        </TabPane>
                    }
                    {
                        <TabPane tab='Coating' key='2'>
                           <CoatingRecordPage />
                        </TabPane>
                    }
                    {
                        <TabPane tab='Competitor' key='3'>
                            <ComingSoon />
                        </TabPane>
                    }

                </Tabs>
            </div>
        );
    }

    return (

        <div className="d-flex flex-column h-100">
           {!isMasterModalVisible && <div>
                <div className="flex-auto">
                    <div className="d-flex mb-3 align-items-center tab-content-title">


                        <div className='back_equip' >
                            <Tooltip title={'Back'} >
                                <ArrowLeftOutlined onClick={(e) => {
                                    history.push('/SmartLync-HomePage');
                                }} />
                            </Tooltip>
                        </div>

                        <Title className="mb-0 add-new-calibration" level={3} style={{ paddingLeft: '30px' }}>
                            Track Record
                        </Title>
                    </div>
                </div>

                {getRecordTabpanes()}
            </div>
            }
            {isMasterModalVisible &&
                <MasteForm
                    isMasterModalVisible={isMasterModalVisible}
                    setIsMasterModalVisible={setIsMasterModalVisible}
                    selectedTap={selectedTap}

                />
            }
        </div>
    );
};



export default connect(null, null)(TrackRecordPage);

